import React from "react";
import Typography from '@material-ui/core/Typography';
import { DateTime } from 'luxon';

const SketchOrderCardRevisionNotes = ({ revisionNotes : { resourceList } }) => 
    (<ul style={{ paddingBottom: '5px' }}>
        {resourceList && resourceList.length > 0 && resourceList.map(rn => (
            <li style={{paddingBottom: '10px'}}>
                <Typography variant='subtitle2'>{DateTime.fromISO(rn.createdAt).toLocaleString(DateTime.DATETIME_FULL)}</Typography>
                <Typography variant='body1'>{rn.note}</Typography>
            </li>
        ))}
    </ul>)

export default SketchOrderCardRevisionNotes;